import { Component } from "react";
import { BarContainer, BarLabel, LabelContainer } from "../assets/style";
import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ProjectBar(props: { user?: any, updatedOn?: any, updatedBy?: any, newEntry?: boolean, status?:any, riskAssessmentStatus?: any }) {
    const { user, updatedOn, updatedBy, newEntry, status, riskAssessmentStatus } = props
    const {t, i18n} = useTranslation();
    return (
        <Box sx={{ mb: '20px' }}>
            <BarContainer>
                <BarLabel>{t("Created By : ")}{user ? user : newEntry ? localStorage.user : "-"}</BarLabel>
                <BarLabel>{t("Updated On : ")}{updatedOn || "-"}</BarLabel>
                <BarLabel>{t("Updated By : ")}{updatedBy || "-"}</BarLabel>
                <BarLabel>{`${t("Status")} : `}{t(status) || "-"}</BarLabel>
                <BarLabel>{`${t("Risk Assessment Status")} : `}{t(riskAssessmentStatus) || "-"}</BarLabel>
            </BarContainer>
        </Box>

    );
}
